import React, { useState } from 'react';
import { CheckCircle, Bell, Zap, Crown, BarChart2 } from 'lucide-react';

const WaitlistPage = ({ currentUser }) => {
  const [email, setEmail] = useState(currentUser?.email || '');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email || !email.includes('@')) return;
    setLoading(true);
    // For now just show success - connect to email list later
    setTimeout(() => { setSubmitted(true); setLoading(false); }, 800);
  };

  return (
    <div style={{ padding: '4rem 1.5rem', fontFamily: 'system-ui, sans-serif' }}>
      
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.35rem 1rem', background: 'rgba(255,170,0,0.08)', border: '1px solid rgba(255,170,0,0.2)', borderRadius: '20px', marginBottom: '1.5rem' }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#ffaa00', display: 'inline-block', boxShadow: '0 0 6px #ffaa00' }} />
          <span style={{ fontSize: '0.75rem', color: '#ffaa00', fontWeight: 700, letterSpacing: '0.08em' }}>CURRENTLY IN BETA · FREE ACCESS</span>
        </div>
        <h1 style={{ fontSize: 'clamp(2rem,5vw,3rem)', fontWeight: 900, color: '#f8fafc', margin: '0 0 1rem', letterSpacing: '-0.03em' }}>
          Paid plans are coming.<br />
          <span style={{ background: 'linear-gradient(135deg,#00ff88,#00d4ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Get early access pricing.
          </span>
        </h1>
        <p style={{ fontSize: '1.05rem', color: '#94a3b8', maxWidth: '520px', margin: '0 auto', lineHeight: 1.7 }}>
          MarketPulze is currently in private invite-only beta. Paid plans are planned for the future — invited members will receive early-bird pricing.
        </p>
      </div>

      {/* Plans Preview */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: '1rem', marginBottom: '3rem' }}>
        {[
          { icon: <BarChart2 size={22}/>, name: 'Free', price: '$0', period: 'forever', color: '#64748b', features: ['Unlimited analysis','All US equities','15-min delayed data','Email support'], current: true },
          { icon: <Zap size={22}/>, name: 'Basic', price: 'Coming Soon', period: '', color: '#00d4ff', features: ['More signals/month','Full analysis history','Priority support','Early bird pricing'], current: false },
          { icon: <Crown size={22}/>, name: 'Premium', price: 'Coming Soon', period: '', color: '#00ff88', features: ['Unlimited signals','Claude AI analysis','Real-time data (future tier)','API access'], current: false, popular: true },
        ].map(plan => (
          <div key={plan.name} style={{ background: 'rgba(10,20,45,0.6)', border: `2px solid ${plan.popular ? 'rgba(0,255,136,0.3)' : 'rgba(255,255,255,0.06)'}`, borderRadius: '16px', padding: '1.5rem', position: 'relative', opacity: plan.current ? 1 : 0.85 }}>
            {plan.popular && <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(135deg,#00ff88,#00d4ff)', borderRadius: '10px', padding: '0.2rem 0.9rem', fontSize: '0.65rem', fontWeight: 900, color: '#050d1a', whiteSpace: 'nowrap' }}>⭐ MOST POPULAR</div>}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1rem', color: plan.color }}>
              {plan.icon}
              <span style={{ fontWeight: 900, fontSize: '1.1rem', color: '#f8fafc' }}>{plan.name}</span>
              {plan.current && <span style={{ fontSize: '0.65rem', padding: '0.1rem 0.5rem', background: 'rgba(0,255,136,0.1)', border: '1px solid rgba(0,255,136,0.2)', borderRadius: '20px', color: '#00ff88', fontWeight: 700 }}>ACTIVE NOW</span>}
            </div>
            <div style={{ fontSize: '1.5rem', fontWeight: 900, color: plan.color, marginBottom: '1rem' }}>{plan.price}</div>
            {plan.features.map((f,i) => (
              <div key={i} style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.4rem', alignItems: 'center' }}>
                <CheckCircle size={13} style={{ color: plan.color, flexShrink: 0 }} />
                <span style={{ fontSize: '0.82rem', color: '#94a3b8' }}>{f}</span>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Waitlist Form */}
      {!submitted ? (
        <div style={{ background: 'linear-gradient(135deg,rgba(0,255,136,0.06),rgba(0,212,255,0.04))', border: '1px solid rgba(0,255,136,0.15)', borderRadius: '20px', padding: '2.5rem', textAlign: 'center' }}>
          <Bell size={32} style={{ color: '#00ff88', marginBottom: '1rem' }} />
          <h2 style={{ color: '#f8fafc', fontWeight: 900, fontSize: '1.5rem', margin: '0 0 0.5rem' }}>Get notified first</h2>
          <p style={{ color: '#64748b', margin: '0 0 1.5rem', fontSize: '0.9rem' }}>Be first to know when paid plans launch. Early-bird members get locked-in pricing.</p>
          <div style={{ display: 'flex', gap: '0.75rem', maxWidth: '440px', margin: '0 auto', flexWrap: 'wrap', justifyContent: 'center' }}>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address"
              style={{ flex: '1 1 240px', padding: '0.85rem 1.25rem', background: 'rgba(5,13,26,0.8)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: '10px', color: '#f8fafc', fontSize: '0.95rem', outline: 'none', fontFamily: 'inherit' }} />
            <button onClick={handleSubmit} disabled={loading}
              style={{ padding: '0.85rem 1.5rem', background: 'linear-gradient(135deg,#00ff88,#00d4ff)', border: 'none', borderRadius: '10px', color: '#050d1a', fontWeight: 800, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', fontFamily: 'inherit', fontSize: '0.95rem' }}>
              {loading ? '...' : <><Bell size={15}/> Notify Me</>}
            </button>
          </div>
          <p style={{ color: '#334155', fontSize: '0.72rem', marginTop: '1rem' }}>No spam. Unsubscribe anytime. Early members get the best pricing.</p>
        </div>
      ) : (
        <div style={{ background: 'rgba(0,255,136,0.06)', border: '1px solid rgba(0,255,136,0.2)', borderRadius: '20px', padding: '2.5rem', textAlign: 'center' }}>
          <CheckCircle size={40} style={{ color: '#00ff88', marginBottom: '1rem' }} />
          <h2 style={{ color: '#00ff88', fontWeight: 900, fontSize: '1.5rem', margin: '0 0 0.5rem' }}>You're on the list! ✅</h2>
          <p style={{ color: '#94a3b8', margin: 0 }}>We'll email you at <strong style={{color:'#f8fafc'}}>{email}</strong> when paid plans launch with your early-bird pricing.</p>
        </div>
      )}

      {/* Disclaimer */}
      <div style={{ marginTop: '2rem', padding: '1rem 1.25rem', background: 'rgba(255,170,0,0.04)', border: '1px solid rgba(255,170,0,0.1)', borderRadius: '10px' }}>
        <p style={{ fontSize: '0.68rem', color: '#475569', margin: 0, lineHeight: 1.7 }}>
          <strong style={{color:'#78716c'}}>⚠️ Beta Disclaimer:</strong> MarketPulze is currently in private invite-only beta. All features are provided free of charge. Algorithmic signals are for informational purposes only and do not constitute investment advice. Data is delayed approximately 15 minutes. MarketPulze is not a registered investment adviser. Pricing shown above is indicative and subject to change before launch.
        </p>
      </div>
    </div>
  );
};

export default WaitlistPage;
